import { component, factory } from 'tsdi';

@component
export class HistoryFactory {
    @factory({ name: 'History' })
    public getHistory(): History {
        return history;
    }
}
